/**
 *  BoostPowerup
 *
 *  Created by Legman on 20/04/2017.
 *
 */

import Boost from "./Boost";
import Common from "../Common";
import Powerup from "./Powerup";

/**
 * @class
 * @extends Powerup
 */
export default class BoostPowerup extends Powerup {
    /**
     * @param collector
     */
    constructor(collector) {
        super(collector);
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        super.update(dt);

        if (this._boost) {
            this._boost.update(dt);
            if (!this._boost.parent) {
                this.destroyNextFrame = true;
            }
        }
    }

    /**
     * @returns {boolean}
     */
    activate() {
        const activated = super.activate();
        if (activated) {
            this._boost = this._createBoost();
            this._boost.powerupType = this.type;
            this._boost.init();
            this._collector.view.addChild(this._boost);

            this._collector.view.visible && Common.audio.playSound("sfx_powerup_speedup_tyre_screech_00");
        }
        return activated;
    }

    /**
     * @returns {Boost}
     * @protected
     */
    _createBoost() {
        return new Boost(this._collector);
    }

    /**
     * @returns {Boost}
     */
    get boost() {
        return this._boost;
    }
}